<template>
  <div class="matrix-header">
    <div class="matrix-header__roles">
      <h2 class="matrix-header__structure">{{ $t('roleMatrix_appStructure') }}</h2>
      <div
        v-for="role in roles"
        :key="role.number"
        class="matrix-header__role"
        :class="{ 'matrix-header__role--focused': focusedRoleNumber === role.number }"
        @click="$emit('focus-role', role.number)"
      >
        <div class="matrix-header__role-title">
          <span class="matrix-header__role-name">{{ role.name }}</span>
          <b-button
            variant="link"
            size="sm"
            class="matrix-header__edit"
            :title="$t('roleMatrix_editRole')"
            @click.stop="$emit('edit-role', role)"
          >
            <i class="fa fa-pencil" />
          </b-button>
        </div>
        <button
          type="button"
          class="matrix-header__members"
          @click.stop="$emit('edit-members', role)"
        >
          {{ role.members.length }} {{ $t('members') }}
        </button>
      </div>
    </div>
    <div class="matrix-header__levels">
      <span class="matrix-header__structure-spacer" />
      <template v-for="role in roles">
        <span
          v-for="(level, levelIndex) in levels"
          :key="`${role.number}-${level}`"
          class="matrix-header__level"
          :class="{ 'matrix-header__level--first': levelIndex === 0 }"
        >
          {{ levelLabels[level] }}
        </span>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MatrixHeader',
  props: {
    roles: { type: Array, required: true },
    levels: { type: Array, required: true },
    levelLabels: { type: Object, required: true },
    focusedRoleNumber: { type: Number, default: null },
  },
};
</script>

<style lang="scss" scoped>
.matrix-header {
  border-bottom: 2px solid $gray-200;
  background-color: $gray-100;
  font-size: 0.875rem;
}

.matrix-header__roles,
.matrix-header__levels {
  display: flex;
}

.matrix-header__levels {
  border-top: 1px solid $gray-200;
}

.matrix-header__structure {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  width: 392px;
  margin: 0;
  padding: 10px 12px;
  color: $gray-500;
  font-size: 0.875rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.matrix-header__structure-spacer {
  flex-shrink: 0;
  width: 392px;
}

.matrix-header__role {
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  justify-content: center;
  width: 144px;
  padding: 8px 10px;
  border-left: 1px solid $gray-200;
  cursor: pointer;

  &--focused {
    background-color: $gray-200;
    box-shadow: inset 0 -3px 0 0 $gray-600;
  }
}

.matrix-header__role-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
}

.matrix-header__role-name {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  font-weight: 600;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.matrix-header__edit {
  flex-shrink: 0;
  padding: 0 4px;
  color: $gray-500;
  font-size: 0.75rem;
}

.matrix-header__members {
  padding: 0;
  border: none;
  background: none;
  color: $gray-500;
  font-size: 0.75rem;
  text-align: left;
  text-decoration: underline;
}

.matrix-header__level {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 72px;
  padding: 4px 0;
  color: $gray-500;

  &--first {
    border-left: 1px solid $gray-200;
  }
}
</style>
